import React from 'react'
import { createRoot } from 'react-dom/client'
import { SpaLayout } from './SpaLayout'
import { NISTTestRunner } from '../app/nist-tests/components/nist-test-runner'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('NIST SPA root element not found')
}

const root = createRoot(rootElement)
root.render(
  <SpaLayout
    title="NIST Test Suite"
    description="Run NIST SP 800-22 statistical tests on entropy generated by Recursive Folding to verify randomness quality."
  >
    <NISTTestRunner />
  </SpaLayout>
)
